import * as yup from 'yup';
import { Language } from '../../models/WinePackageWidgetModel';

export const validationSchema = yup.object().shape({
  widgetTitle: yup.lazy((widgetTitle) => {
    const languages = Object.keys(widgetTitle);

    return yup.object().shape({
      ...languages.reduce((lang, value) => {
        lang[value] = yup.object().shape({
          title: yup.string().required(`${value.toUpperCase()} cím megadása kötelező`) as yup.StringSchema<string>,
        });

        return lang;
      }, {} as Record<string, yup.ObjectSchema<Language>>),
    });
  }),

  textColor: yup.string().required('Szöveg szín megadása kötelező'),
  backgroundColor: yup.string().required('Háttér szín megadása kötelező'),
  scrollbarColor: yup.string().required('Scrollbar szín megadása kötelező'),
  renderedPackages: yup
    .number()
    .typeError('Megjelenítendő borcsomagok számának megadása kötelező')
    .required('Megjelenített borcsomagok számának megadása kötelező')
    .min(1, 'Megjelenített borcsomagok száma nem lehet kisebb 1-nél'),
  packages: yup.array().min(1, 'Legalább 1 borcsomag hozzáadása kötlező'),
});
